module.exports = __webpack_public_path__ + "img/horizontal_4_6_r_pp3_9005.ee7f2207.png";